 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-0a4313fa":"21fd8910","chunk-0b1306c4":"b7751ceb","chunk-2af52a52":"8200ab0c","chunk-2d0ac931":"cc71baa3","chunk-2d0af12b":"a6da1f94","chunk-2d0b8b30":"5da32a40","chunk-2d0bd5f7":"48e3b21c","chunk-2d0c211b":"56bba833","chunk-2d0c8871":"190339e6","chunk-2d0cf315":"c8f5219d","chunk-2d0d3c84":"8ae4ece4","chunk-2d0d6d65":"64418c4d","chunk-2d0e2170":"5a3fb417","chunk-2d0e9381":"581b25ba","chunk-2d2080c7":"df635c1b","chunk-2d208d71":"c1139155","chunk-2d210953":"dad45e18","chunk-2d212be3":"2b736999","chunk-2d217def":"9b86ebe8","chunk-2d21a9aa":"bdd6764c","chunk-2d21d677":"fea28098","chunk-2d222064":"af9a1ad0","chunk-2d222cca":"4226e9f6","chunk-2d22895d":"4ebcf334","chunk-2d22fd4f":"fc2f36aa","chunk-2d230311":"3676967c","chunk-2d230848":"0dbf96a3","chunk-2d23721e":"7970ea5d","chunk-4870e7db":"dbfaf151","chunk-3be763f4":"b95c9cfa","chunk-6fc1790c":"383c640a","chunk-76c6de86":"0b032813","chunk-2d0e6104":"27817bd9","chunk-7a835fe8":"453692f6","chunk-918089f0":"b4299a52","chunk-91dee78a":"6f3f2934","chunk-a7314450":"58d20fba","chunk-15621a6a":"2bed5adc","chunk-b5ad85ba":"f82893a9","stencil-polyfills-css-shim":"b85f8bdc","stencil-polyfills-dom":"6e9caa76","chunk-2d216786":"e7964bdb","chunk-040b3a4a":"b182f837","chunk-04401b6a":"37fbc71e","chunk-05c5c25b":"a3b4e438","chunk-0900ddec":"17c44e8d","chunk-0fc47438":"c4eb0b54","chunk-1472d5a8":"95c8561f","chunk-154b8582":"5ece38af","chunk-1b36dff8":"6f043bfa","chunk-1b388c0c":"d6a4b2ee","chunk-1beb23ce":"237d3b69","chunk-1da7959b":"9bf8f2cb","chunk-20487cd4":"420292ae","chunk-23fd4b30":"c5aaea17","chunk-25c3bca1":"ab90bc59","chunk-2adbe215":"209ea689","chunk-2af2f2e0":"a1b2b8da","chunk-2d0a4bee":"975bd915","chunk-2d0c073f":"5d7fe705","chunk-2d0c09f7":"e86eaebb","chunk-2d0c9765":"6a8a5a7b","chunk-2d0cf9fe":"82db8e0e","chunk-2d0cfdea":"e2fc2947","chunk-2d0d01ba":"c60e57bf","chunk-2d0d6927":"65be9ca1","chunk-2d0d6bbc":"e39bc8d8","chunk-2d0d9f47":"16f56f74","chunk-2d0da04a":"2128408d","chunk-2d0ddfae":"9637a5a3","chunk-2d0e4a64":"6c851223","chunk-2d0e5812":"ea3b9e64","chunk-2d0f064c":"3a69c525","chunk-2d213189":"8bc9c8bd","chunk-2d2172eb":"2d08e728","chunk-2d218068":"4ac4a1a4","chunk-2d21e44f":"1b4de5fd","chunk-2d21f23d":"5f421e86","chunk-2d221b5b":"047015cc","chunk-2d225457":"b24e6e02","chunk-2d2300e4":"099b4a82","chunk-2d237d41":"7deef0ce","chunk-306aae5b":"83922d51","chunk-3106975e":"a573897a","chunk-361f102c":"0846f0f0","chunk-41ac779d":"a0bc4796","chunk-41aebc17":"254b2a84","chunk-41b313ed":"8a703336","chunk-42383450":"08cc0f69","chunk-4261ce5e":"d6f2eb98","chunk-4280cae0":"091d5954","chunk-489f5ed6":"d779317f","chunk-497503be":"c1a4cb8c","chunk-4ef27cba":"5eb37e5c","chunk-540a2426":"0f613c43","chunk-59fdc88a":"5bc69c49","chunk-5d8ee71f":"9b243393","chunk-60d0c2df":"d37d8ea8","chunk-614248c0":"d96f361d","chunk-69408703":"af3c9a70","chunk-6d22df2d":"bd7fa905","chunk-70150ee1":"bac6b6ae","chunk-7b6dc66e":"d6100b6b","chunk-7fa1996c":"d6b11f0f","chunk-90235264":"f5f409dd","chunk-902d16ba":"dd30420e","chunk-9599df6a":"2ffabae8","chunk-98b29e06":"a00c88c7","chunk-a946ac8e":"366b6588","chunk-bd93dd40":"690fd5ed","chunk-f0807d24":"c7b05052","chunk-086a213a":"55aab37a","chunk-2d216214":"0bbc55e6","chunk-2d216257":"69e90091","chunk-2d0ab84b":"93ec266b","chunk-2d0cc7f8":"6e470be7","chunk-2d238687":"375c7d7e","chunk-77280396":"2e702841"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0a4313fa":1,"chunk-0b1306c4":1,"chunk-2af52a52":1,"chunk-4870e7db":1,"chunk-3be763f4":1,"chunk-6fc1790c":1,"chunk-76c6de86":1,"chunk-7a835fe8":1,"chunk-918089f0":1,"chunk-91dee78a":1,"chunk-a7314450":1,"chunk-15621a6a":1,"chunk-b5ad85ba":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-0a4313fa":"ea2684bf","chunk-0b1306c4":"880183de","chunk-2af52a52":"6151da76","chunk-2d0ac931":"31d6cfe0","chunk-2d0af12b":"31d6cfe0","chunk-2d0b8b30":"31d6cfe0","chunk-2d0bd5f7":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0c8871":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d0d3c84":"31d6cfe0","chunk-2d0d6d65":"31d6cfe0","chunk-2d0e2170":"31d6cfe0","chunk-2d0e9381":"31d6cfe0","chunk-2d2080c7":"31d6cfe0","chunk-2d208d71":"31d6cfe0","chunk-2d210953":"31d6cfe0","chunk-2d212be3":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d21d677":"31d6cfe0","chunk-2d222064":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d22fd4f":"31d6cfe0","chunk-2d230311":"31d6cfe0","chunk-2d230848":"31d6cfe0","chunk-2d23721e":"31d6cfe0","chunk-4870e7db":"20d530cd","chunk-3be763f4":"31039008","chunk-6fc1790c":"444c6236","chunk-76c6de86":"86d4cf5a","chunk-2d0e6104":"31d6cfe0","chunk-7a835fe8":"19440a63","chunk-918089f0":"ad4c1926","chunk-91dee78a":"0b51f8b3","chunk-a7314450":"dfbb0c2e","chunk-15621a6a":"35904a07","chunk-b5ad85ba":"e6b29f23","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0","chunk-2d216786":"31d6cfe0","chunk-040b3a4a":"31d6cfe0","chunk-04401b6a":"31d6cfe0","chunk-05c5c25b":"31d6cfe0","chunk-0900ddec":"31d6cfe0","chunk-0fc47438":"31d6cfe0","chunk-1472d5a8":"31d6cfe0","chunk-154b8582":"31d6cfe0","chunk-1b36dff8":"31d6cfe0","chunk-1b388c0c":"31d6cfe0","chunk-1beb23ce":"31d6cfe0","chunk-1da7959b":"31d6cfe0","chunk-20487cd4":"31d6cfe0","chunk-23fd4b30":"31d6cfe0","chunk-25c3bca1":"31d6cfe0","chunk-2adbe215":"31d6cfe0","chunk-2af2f2e0":"31d6cfe0","chunk-2d0a4bee":"31d6cfe0","chunk-2d0c073f":"31d6cfe0","chunk-2d0c09f7":"31d6cfe0","chunk-2d0c9765":"31d6cfe0","chunk-2d0cf9fe":"31d6cfe0","chunk-2d0cfdea":"31d6cfe0","chunk-2d0d01ba":"31d6cfe0","chunk-2d0d6927":"31d6cfe0","chunk-2d0d6bbc":"31d6cfe0","chunk-2d0d9f47":"31d6cfe0","chunk-2d0da04a":"31d6cfe0","chunk-2d0ddfae":"31d6cfe0","chunk-2d0e4a64":"31d6cfe0","chunk-2d0e5812":"31d6cfe0","chunk-2d0f064c":"31d6cfe0","chunk-2d213189":"31d6cfe0","chunk-2d2172eb":"31d6cfe0","chunk-2d218068":"31d6cfe0","chunk-2d21e44f":"31d6cfe0","chunk-2d21f23d":"31d6cfe0","chunk-2d221b5b":"31d6cfe0","chunk-2d225457":"31d6cfe0","chunk-2d2300e4":"31d6cfe0","chunk-2d237d41":"31d6cfe0","chunk-306aae5b":"31d6cfe0","chunk-3106975e":"31d6cfe0","chunk-361f102c":"31d6cfe0","chunk-41ac779d":"31d6cfe0","chunk-41aebc17":"31d6cfe0","chunk-41b313ed":"31d6cfe0","chunk-42383450":"31d6cfe0","chunk-4261ce5e":"31d6cfe0","chunk-4280cae0":"31d6cfe0","chunk-489f5ed6":"31d6cfe0","chunk-497503be":"31d6cfe0","chunk-4ef27cba":"31d6cfe0","chunk-540a2426":"31d6cfe0","chunk-59fdc88a":"31d6cfe0","chunk-5d8ee71f":"31d6cfe0","chunk-60d0c2df":"31d6cfe0","chunk-614248c0":"31d6cfe0","chunk-69408703":"31d6cfe0","chunk-6d22df2d":"31d6cfe0","chunk-70150ee1":"31d6cfe0","chunk-7b6dc66e":"31d6cfe0","chunk-7fa1996c":"31d6cfe0","chunk-90235264":"31d6cfe0","chunk-902d16ba":"31d6cfe0","chunk-9599df6a":"31d6cfe0","chunk-98b29e06":"31d6cfe0","chunk-a946ac8e":"31d6cfe0","chunk-bd93dd40":"31d6cfe0","chunk-f0807d24":"31d6cfe0","chunk-086a213a":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-2d0ab84b":"31d6cfe0","chunk-2d0cc7f8":"31d6cfe0","chunk-2d238687":"31d6cfe0","chunk-77280396":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
